module.exports = __webpack_public_path__ + "img/floppy-icon.bb2d3c7c.svg";